import { Page, PathButton } from "shared/react";
import { NOTES_MAX } from "shared/schema";
import { NoteList } from "../note/NoteList.js";
import { useCreatorAllowedPrivacy } from "../util/privacy.js";
import { CreatorCondition } from "./CreatorCondition.js";
import { useCreatorContext } from "./CreatorContext.js";
import { EntityHeader } from "../entity/EntityHeader.js";

export function NotesCreatedPage(): React.ReactElement {
	const creator = useCreatorContext();
	const privacy = useCreatorAllowedPrivacy(creator);
	return (
		<Page title="Created notes" path="./notes">
			<EntityHeader entity={creator}>
				<h1>Created notes</h1>
			</EntityHeader>
			<CreatorCondition creator={creator}>
				<section>
					<PathButton path="./new">Create note</PathButton>
				</section>
			</CreatorCondition>
			<NoteList
				query={{
					creator,
					privacy,
					$order: "name",
					$limit: NOTES_MAX,
				}}
				empty="No created lists"
			/>
		</Page>
	);
}
